const productName = "Pikbase";
export const brand = {
    productName,
    workspaceName: `${productName} Workspace`,
    /** @deprecated Use workspaceName. */
    consoleName: `${productName} Console`,
    accountName: `${productName} Account`,
    /** Account-level team that shares billing; distinct from a workspace's members. */
    teamName: `${productName} Team`,
    tagline: "Your backend is ready. Build the application.",
    definition: "Define your business rules and build the frontend. Pikbase runs the governed data, permissions, functions, workflows, documents, audit, and operations behind it.",
    urls: {
        website: "https://pikbase.com",
        docs: "https://docs.pikbase.com",
        account: "https://account.pikbase.com",
        workspace: "https://workspace.pikbase.com",
        /** @deprecated Use workspace. */
        console: "https://workspace.pikbase.com",
        status: "https://status.pikbase.com",
    },
    legalOwner: "Apexbase LLC",
    /** Registered address; required in the footer of any bulk or commercial email. */
    legalAddress: {
        street: "1209 Mountain Road PL NE Ste N",
        locality: "Albuquerque",
        region: "NM",
        postalCode: "87110",
        country: "United States",
    },
    internalSystem: "GSB Core",
};
export function interpolateBrand(template, values = {}) {
    return template.replaceAll("{{brand}}", values.brand ?? brand.productName);
}
//# sourceMappingURL=brand.js.map